import './App.css';
import AppRoute from './Routes';

function App() {
  return (
    <>
      <AppRoute />
    </>
  );
}

export default App;
